module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"head":"See what our customers say about bonkers.ie","rating":"{0} out of 5","ratingTotal":"Rating based on {total}  verified feefo reviews","readAll":"Read all reviews"}}')
  delete Component.options._Ctor
}
